import { Calendar, DateField, DatePicker, Input, Label, TextArea } from "@heroui/react";
import GooglePlacesSearchDropdown from "@/components/maps/location-search";
import { MapPin, Calendar as CalendarIcon, Clock } from "lucide-react";
import TimeWheelInline from "../../time-wheel/time-wheel-inline";
import { getReadableTimeDiff } from "@/utils/dates";

const DetailsStep = ({ formData, updateFormData }) => {
  const inputClass =
    "border h-[36px] rounded-xl shadow-none border-px border-field-border dark:border-white/25 bg-field-background";
  const labelClass = "flex items-center gap-1 dark:text-[#AFAFAF] text-xs";
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label className={labelClass}>
          <img src="/icons/title-icon.svg" /> Title
        </Label>
        <Input
          placeholder="Quick Sync"
          className={inputClass}
          value={formData.title}
          onChange={(e) => updateFormData({ title: e.target.value })}
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <Label className={labelClass}>
          {" "}
          <CalendarIcon size={12} className="" /> Event Date
        </Label>
        <DatePicker
          name="date"
          value={formData.date}
          onChange={(dateValue) => updateFormData({ date: dateValue })}
          className={"shadow-none"}
        >
          <DateField.Group fullWidth className={inputClass}>
            <DateField.Input>{(segment) => <DateField.Segment segment={segment} />}</DateField.Input>
            <DateField.Suffix>
              <DatePicker.Trigger className={"shadow-none border border-separator"}>
                <DatePicker.TriggerIndicator />
              </DatePicker.Trigger>
            </DateField.Suffix>
          </DateField.Group>
          <DatePicker.Popover>
            <Calendar aria-label="Event date">
              <Calendar.Header>
                <Calendar.YearPickerTrigger>
                  <Calendar.YearPickerTriggerHeading />
                  <Calendar.YearPickerTriggerIndicator />
                </Calendar.YearPickerTrigger>
                <Calendar.NavButton slot="previous" />
                <Calendar.NavButton slot="next" />
              </Calendar.Header>
              <Calendar.Grid>
                <Calendar.GridHeader>{(day) => <Calendar.HeaderCell>{day}</Calendar.HeaderCell>}</Calendar.GridHeader>
                <Calendar.GridBody>{(date) => <Calendar.Cell date={date} />}</Calendar.GridBody>
              </Calendar.Grid>
              <Calendar.YearPickerGrid>
                <Calendar.YearPickerGridBody>
                  {({ year }) => <Calendar.YearPickerCell year={year} />}
                </Calendar.YearPickerGridBody>
              </Calendar.YearPickerGrid>
            </Calendar>
          </DatePicker.Popover>
        </DatePicker>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label className={labelClass}>
          {" "}
          <MapPin size={16} /> Location
        </Label>

        <GooglePlacesSearchDropdown
          onSelect={(place) => updateFormData({ location: place })}
          placeholder="Type an address or place"
          inputClassName={'border-r-0 shadow-none h-9 bg-background! border-y-muted/20 border-y-1 border-r-0'}
          className={inputClass}
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <Label className={labelClass}>
          {" "}
          <Clock size={16} /> <span>Duration: {getReadableTimeDiff(formData.startTime, formData.endTime)}</span>
        </Label>

        <div className="flex items-center gap-2">
          <TimeWheelInline
            value={formData.startTime}
            onSelect={(t) => updateFormData({ startTime: t })}
            minuteStep={15}
          />
          <span className="text-muted">-</span>
          <TimeWheelInline value={formData.endTime} onSelect={(t) => updateFormData({ endTime: t })} minuteStep={15} />
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label className={labelClass}>
          {" "}
          <div className="flex flex-row gap-1">
            <img src="/icons/description-icon.svg" /> Description
          </div>
          <span className="text-xs text-muted">(Optional)</span>
        </Label>
        <TextArea
          className={inputClass.replace("h-[36px]", "min-h-[80px]")}
          value={formData.description}
          onChange={(e) => updateFormData({ description: e.target.value })}
          placeholder="Description of the event ..."
        />
      </div>
    <div className="flex flex-col gap-2 text-sm">
        <label className="flex gap-3 items-center">Repeat
          <select aria-label="Repeat frequency" value={formData.recurrence?.frequency || "once"}
            onChange={e => updateFormData({ recurrence: { ...formData.recurrence, frequency: e.target.value, count: formData.recurrence?.count || 4 } })}>
            {["once", "daily", "weekly", "monthly"].map(value => <option key={value}>{value}</option>)}
          </select>
        </label>
        {formData.recurrence?.frequency !== "once" && formData.recurrence && <label>Occurrences (including this meeting)
          <input aria-label="Occurrences" type="number" min="2" max="52" value={formData.recurrence.count}
            onChange={e => updateFormData({ recurrence: { ...formData.recurrence, count: Number(e.target.value) } })} />
        </label>}
      </div>
      </div>
  );
};

export default DetailsStep;
